(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero--photo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.hpcInit === 'true') return;
      root.dataset.hpcInit = 'true';

      var track = root.querySelector('[data-hpc-track]');
      if (!track) return;
      var dotsWrap = root.querySelector('[data-hpc-dots]');
      var index = 0;
      var timer = null;
      var delay = (parseFloat(root.dataset.autoplay) || 4) * 1000;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function count() {
        return track.children.length;
      }

      var dots = [];
      if (dotsWrap && count() > 1) {
        for (var i = 0; i < count(); i++) {
          (function (i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'hpc__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', function () {
              goTo(i);
              restart();
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          })(i);
        }
      }

      function setActiveDot(i) {
        dots.forEach(function (d, j) {
          d.classList.toggle('is-active', j === i);
        });
      }

      function goTo(i) {
        var total = count();
        var width = track.clientWidth;
        if (!total || !width) return;
        var target = ((i % total) + total) % total;
        // Long jumps (e.g. wrapping from the last slide back to the first)
        // fight `scroll-snap-stop: always`: the browser can halt the smooth
        // scroll at the first intermediate slide, which stalls the carousel
        // once there are three or more slides. Jump those instantly instead.
        var current = Math.round(track.scrollLeft / width);
        var behavior = 'smooth';
        if (reduceMotion || Math.abs(target - current) > 1) behavior = 'auto';
        index = target;
        track.scrollTo({ left: width * index, behavior: behavior });
        setActiveDot(index);
      }

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var width = track.clientWidth;
          if (!width) return;
          var i = Math.round(track.scrollLeft / width);
          if (i !== index && i >= 0 && i < count()) {
            index = i;
            setActiveDot(index);
          }
        }, 80);
      });

      // Keep the current slide aligned when the viewport size changes.
      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          if (!track.clientWidth) return;
          track.scrollTo({ left: track.clientWidth * index, behavior: 'auto' });
        }, 150);
      });

      function start() {
        if (reduceMotion || count() < 2 || timer) return;
        timer = setInterval(function () {
          if (document.hidden) return;
          goTo(index + 1);
        }, delay);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function restart() {
        stop();
        start();
      }

      // Autoplay keeps running on desktop - no hover pause. It only pauses
      // while the user is actively touch-dragging on mobile.
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', function () {
        setTimeout(start, 1500);
      }, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) restart();
      });

      start();
    }

    function initAll() {
      document.querySelectorAll('[data-hpc]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-hpc]');
      if (root) {
        root.dataset.hpcInit = '';
        initCarousel(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SCENTS = {
      lavender: { name: 'Lavender', tagline: 'Calm in a stick. Soft, floral, and endlessly classic.', light: '#cdbfe6', dark: '#6f5f96' },
      jasmine: { name: 'Jasmine', tagline: 'Sweet white florals that feel like a slow Sunday morning.', light: '#f7f0d8', dark: '#cdb96a' },
      orangevanilla: { name: 'Orange Vanilla', tagline: 'Bright citrus wrapped in warm vanilla. Basically a creamsicle for your underarms.', light: '#f6d3a2', dark: '#d97f2f' },
      vanillapeppermint: { name: 'Vanilla Peppermint', tagline: 'Cool mint meets cozy vanilla. Fresh, never frosty.', light: '#f8dcdc', dark: '#a8433f' },
      coconutlime: { name: 'Coconut Lime', tagline: 'Creamy coconut with a squeeze of lime. Vacation, bottled.', light: '#dcedcb', dark: '#6fa25b' },
      charcoalseaside: { name: 'Charcoal Seaside', tagline: 'Crisp ocean air with detox charcoal. Take a deep breath.', light: '#aebfc9', dark: '#31434f' },
      woodlands: { name: 'Woodlands', tagline: 'Pine trails and fresh green air. Grounded, free, and a little wild.', light: '#b3c6a6', dark: '#3f5c37' },
      unscented: { name: 'Unscented', tagline: 'Zero fragrance. Maximum performance. Frankly unbeatable.', light: '#ece7df', dark: '#a9a094' }
    };

    var PRODUCT_HANDLES = {
      bs: 'baking-soda-stick',
      bsf: 'baking-soda-free-stick'
    };

    var BRANCHES = {
      florals: {
        kind: 'scent',
        q: 'Perfect. Which floral?',
        options: [
          { label: 'Lavender. Calm, classic, always works', pts: { lavender: 3 } },
          { label: 'Jasmine. Sweet, soft, a little dreamy', pts: { jasmine: 3 } },
          { label: 'Florals with a fresh twist of mint', pts: { vanillapeppermint: 3 } },
          { label: 'Actually, something greener', pts: { woodlands: 3 } }
        ]
      },
      bright: {
        kind: 'scent',
        q: 'Nice. Which kind of bright?',
        options: [
          { label: 'Coconut and lime, beach day forever', pts: { coconutlime: 3 } },
          { label: 'Orange and vanilla, creamsicle energy', pts: { orangevanilla: 3 } },
          { label: 'Cool peppermint meets warm vanilla', pts: { vanillapeppermint: 3 } },
          { label: 'Clean ocean air with charcoal', pts: { charcoalseaside: 3 } }
        ]
      },
      earthy: {
        kind: 'scent',
        q: 'Love it. How deep into the woods?',
        options: [
          { label: 'Full pine forest, lace up the boots', pts: { woodlands: 3 } },
          { label: 'Salt air and coastal cliffs', pts: { charcoalseaside: 3 } },
          { label: 'Herbal and calming, garden vibes', pts: { lavender: 3 } },
          { label: 'Earthy but sweet, keep it cozy', pts: { orangevanilla: 3 } }
        ]
      }
    };

    var QUESTIONS = [
      {
        kind: 'scent',
        q: 'Frankly, what do you want to smell like?',
        options: [
          { label: 'Soft, calming florals', pts: { lavender: 2, jasmine: 1 }, branch: 'florals' },
          { label: 'Bright, fresh, and fruity', pts: { coconutlime: 2, orangevanilla: 1 }, branch: 'bright' },
          { label: 'Earthy and outdoorsy', pts: { woodlands: 2, charcoalseaside: 1 }, branch: 'earthy' },
          { label: 'Nothing at all. Just keep me fresh', noScent: true }
        ]
      },
      {
        kind: 'scent',
        placeholder: true,
        q: 'Nice. Which kind of bright?',
        options: []
      },
      {
        kind: 'formula',
        q: 'Now, strength. Which sounds most like you?',
        options: [
          { label: "I'm active. I need something that can keep up", formulaPts: { bs: 2 } },
          { label: 'Long days, high stress, zero time for touch ups', formulaPts: { bs: 2 } },
          { label: 'My skin is picky about what touches it', formulaPts: { bsf: 2 } },
          { label: 'Deodorants have irritated my skin before', formulaPts: { bsf: 2 } }
        ]
      },
      {
        kind: 'formula',
        q: "Last one. Your new deodorant's job description:",
        options: [
          { label: 'Outwork my toughest workouts', formulaPts: { bs: 2 } },
          { label: 'Show up strong on 14 hour days', formulaPts: { bs: 2 } },
          { label: 'Stay gentle on my sensitive skin', formulaPts: { bsf: 2 } },
          { label: 'Keep me comfortable, zero irritation', formulaPts: { bsf: 2 } }
        ]
      }
    ];

    function initQuiz(root) {
      var body = root.querySelector('[data-quiz-body]');
      if (!body) return;
      var queue = [];
      var answered = 0;
      var scores = {};
      var lastScored = {};
      var scoreTick = 0;
      var formulaScores = { bs: 0, bsf: 0 };
      var scentLocked = false;

      function reset() {
        queue = QUESTIONS.slice();
        answered = 0;
        scores = {};
        lastScored = {};
        scoreTick = 0;
        formulaScores = { bs: 0, bsf: 0 };
        scentLocked = false;
      }

      function renderProgress() {
        var total = answered + queue.length;
        var wrap = document.createElement('div');
        wrap.className = 'squiz-progress';
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('span');
          dot.className = 'squiz-progress__dot';
          if (i < answered) dot.classList.add('is-done');
          if (i === answered) dot.classList.add('is-current');
          wrap.appendChild(dot);
        }
        return wrap;
      }

      function renderQuestion() {
        var item = queue[0];
        body.innerHTML = '';
        body.classList.remove('squiz-anim');
        void body.offsetWidth;
        body.classList.add('squiz-anim');

        body.appendChild(renderProgress());

        var count = document.createElement('p');
        count.className = 'squiz-count';
        count.textContent = 'Question ' + (answered + 1) + ' of ' + (answered + queue.length);
        body.appendChild(count);

        var question = document.createElement('p');
        question.className = 'squiz-question';
        question.textContent = item.q;
        body.appendChild(question);

        var wrap = document.createElement('div');
        wrap.className = 'squiz-options';
        item.options.forEach(function (opt) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'squiz-option';
          btn.textContent = opt.label;
          btn.addEventListener('click', function () {
            scoreTick += 1;
            if (opt.pts) {
              Object.keys(opt.pts).forEach(function (key) {
                scores[key] = (scores[key] || 0) + opt.pts[key];
                if (opt.pts[key] >= 2) {
                  lastScored[key] = scoreTick;
                }
              });
            }
            if (opt.formulaPts) {
              Object.keys(opt.formulaPts).forEach(function (key) {
                formulaScores[key] = (formulaScores[key] || 0) + opt.formulaPts[key];
              });
            }
            if (opt.noScent) {
              scentLocked = true;
            }

            queue.shift();
            answered += 1;

            if (opt.branch && queue.length && queue[0].placeholder) {
              queue[0] = BRANCHES[opt.branch];
            }

            if (scentLocked) {
              queue = queue.filter(function (q) {
                return q.kind !== 'scent';
              });
            }

            if (queue.length > 0) {
              renderQuestion();
            } else {
              renderResult();
            }
          });
          wrap.appendChild(btn);
        });
        body.appendChild(wrap);
      }

      function winningScent() {
        if (scentLocked) return 'unscented';
        var bestKey = null;
        var bestScore = -1;
        var bestRecency = -1;
        Object.keys(SCENTS).forEach(function (key) {
          if (key === 'unscented') return;
          var s = scores[key] || 0;
          var recency = lastScored[key] || 0;
          if (s > bestScore || (s === bestScore && recency > bestRecency)) {
            bestScore = s;
            bestRecency = recency;
            bestKey = key;
          }
        });
        return bestKey || 'lavender';
      }

      function winningFormula() {
        return formulaScores.bs > formulaScores.bsf ? 'bs' : 'bsf';
      }

      function findScentTile(name) {
        var tiles = document.querySelectorAll('[data-shop-by-scent] [data-scent-target]');
        for (var i = 0; i < tiles.length; i++) {
          var label = tiles[i].querySelector('.sbs-tile__label');
          if (label && label.textContent.trim().toLowerCase() === name.toLowerCase()) {
            return tiles[i];
          }
        }
        return null;
      }

      function addDetail(container, label, value) {
        var row = document.createElement('div');
        row.className = 'squiz-result__detail';
        var l = document.createElement('span');
        l.className = 'squiz-result__detail-label';
        l.textContent = label;
        var v = document.createElement('span');
        v.className = 'squiz-result__detail-value';
        v.textContent = value;
        row.appendChild(l);
        row.appendChild(v);
        container.appendChild(row);
      }

      function renderResult() {
        var key = winningScent();
        var scent = SCENTS[key];
        var formula = winningFormula();
        var handle = PRODUCT_HANDLES[formula];
        var formulaText = formula === 'bs' ? 'Extra Strength (Baking Soda)' : 'Sensitive Skin (Baking Soda Free)';

        body.innerHTML = '';
        var result = document.createElement('div');
        result.className = 'squiz-result';

        var eyebrow = document.createElement('p');
        eyebrow.className = 'squiz-result__eyebrow';
        eyebrow.textContent = "It's a match!";
        result.appendChild(eyebrow);

        var swatch = document.createElement('div');
        swatch.className = 'squiz-result__swatch';
        var tile = findScentTile(scent.name);
        var tileImg = tile ? tile.querySelector('.sbs-tile__img') : null;
        var tileSrc = tileImg ? tileImg.currentSrc || tileImg.getAttribute('src') : null;
        if (tileSrc) {
          var img = document.createElement('img');
          img.src = tileSrc;
          img.alt = scent.name;
          swatch.appendChild(img);
        } else {
          swatch.style.backgroundImage = 'radial-gradient(circle at 32% 28%, ' + scent.light + ', ' + scent.dark + ')';
        }
        result.appendChild(swatch);

        var name = document.createElement('p');
        name.className = 'squiz-result__name';
        name.textContent = scent.name;
        result.appendChild(name);

        var tagline = document.createElement('p');
        tagline.className = 'squiz-result__tagline';
        tagline.textContent = scent.tagline;
        result.appendChild(tagline);

        var details = document.createElement('div');
        details.className = 'squiz-result__details';
        addDetail(details, 'Scent', scent.name);
        addDetail(details, 'Formula', formulaText);
        result.appendChild(details);

        // Add to cart directly through the matching Shop by Scent card:
        // no page load, no PDP detour — the cart drawer opens on success.
        var cta = document.createElement('button');
        cta.type = 'button';
        cta.className = 'squiz-result__btn';
        cta.textContent = 'Add ' + scent.name + ' to Cart';
        cta.addEventListener('click', function () {
          var sbsRoot = document.querySelector('[data-shop-by-scent]');
          var tile = findScentTile(scent.name);
          if (sbsRoot && tile) {
            tile.click();
            var card = sbsRoot.querySelector('.sbs-card[data-product-handle="' + handle + '"]:not(.sbs-hide)');
            var form = card ? card.querySelector('form[data-sbs-atc]') : null;
            if (form) {
              cta.disabled = true;
              cta.textContent = 'Adding...';
              if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
              } else {
                form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
              }
              setTimeout(function () {
                cta.textContent = 'Added ✓';
                cta.disabled = false;
              }, 1200);
              return;
            }
            // Scent exists but no add-to-cart form (e.g. sold out):
            // reveal it in Shop by Scent instead of dead-ending.
            sbsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          window.location.href = '/products/' + handle;
        });
        result.appendChild(cta);

        var seeIt = document.createElement('button');
        seeIt.type = 'button';
        seeIt.className = 'squiz-result__secondary';
        seeIt.textContent = 'See it in Shop by Scent';
        seeIt.addEventListener('click', function () {
          var sbsRoot = document.querySelector('[data-shop-by-scent]');
          var tile = findScentTile(scent.name);
          if (tile) tile.click();
          if (sbsRoot) sbsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        result.appendChild(seeIt);

        var retake = document.createElement('button');
        retake.type = 'button';
        retake.className = 'squiz-retake';
        retake.textContent = 'Not you? Retake the quiz';
        retake.addEventListener('click', function () {
          reset();
          renderQuestion();
        });
        result.appendChild(retake);

        body.appendChild(result);
      }

      reset();
      renderQuestion();
    }

    function initAll() {
      document.querySelectorAll('[data-scent-quiz]').forEach(initQuiz);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-scent-quiz]');
      if (root) initQuiz(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-scent"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopByScent(root) {
      var tiles = root.querySelectorAll('[data-scent-target]');
      var items = root.querySelectorAll('[data-scent]');
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          tiles.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tile.classList.add('is-active');
          tile.setAttribute('aria-selected', 'true');
          var id = tile.getAttribute('data-scent-target');
          items.forEach(function (item) {
            var show = item.getAttribute('data-scent') === id;
            item.classList.toggle('sbs-hide', !show);
            if (show) {
              item.classList.remove('sbs-anim');
              void item.offsetWidth;
              item.classList.add('sbs-anim');
            }
          });
        });
      });

      root.querySelectorAll('[data-sbs-atc]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (!btn || btn.disabled) return;
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              return response.json();
            })
            .then(function () {
              btn.textContent = 'Added ✓';
              setTimeout(function () {
                btn.textContent = originalText.trim();
                btn.disabled = false;
              }, 1500);
              window.dispatchEvent(new CustomEvent('custom:open-cart-drawer'));
            })
            .catch(function () {
              btn.textContent = originalText.trim();
              btn.disabled = false;
              form.submit();
            });
        });
      });

      // Back-in-stock signup confirmation (after the customer form redirects back).
      try {
        if (window.location.search.indexOf('back_in_stock=1') > -1) {
          var toast = root.querySelector('[data-sbs-bis-toast]');
          if (toast) {
            toast.hidden = false;
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, '', window.location.pathname);
          }
        }
      } catch (e) {
        /* no-op */
      }
    }

    function normalizeScent(s) {
      return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function activateScentByName(name, scroll) {
      var root = document.querySelector('[data-shop-by-scent]');
      if (!root) return false;
      var tiles = root.querySelectorAll('[data-scent-target]');
      var target = normalizeScent(name);
      for (var i = 0; i < tiles.length; i++) {
        var label = tiles[i].querySelector('.sbs-tile__label');
        if (label && normalizeScent(label.textContent) === target) {
          tiles[i].click();
          if (scroll) {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return true;
        }
      }
      return false;
    }

    // Any link like <a href="#scent=orange-vanilla"> (e.g. hero buttons) jumps
    // to this section with that scent pre-selected — no page change.
    if (!window.__sbsScentLinksBound) {
      window.__sbsScentLinksBound = true;
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href*="#scent="]');
        if (!a) return;
        var name = decodeURIComponent((a.getAttribute('href') || '').split('#scent=')[1] || '');
        if (!name) return;
        if (activateScentByName(name, true)) {
          e.preventDefault();
        }
      });
    }

    // Arriving from another page with /#scent=... in the URL.
    function handleScentHash() {
      var h = window.location.hash || '';
      if (h.indexOf('#scent=') === 0) {
        var name = decodeURIComponent(h.slice(7));
        setTimeout(function () {
          activateScentByName(name, true);
        }, 250);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-shop-by-scent]').forEach(initShopByScent);
      handleScentHash();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-shop-by-scent]');
      if (root) initShopByScent(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
